import Link from 'next/link';
import { FC } from 'react';

import { Box, Group, Stack, Text } from '@mantine/core';

import { InboxNotification } from 'models';

import { useTeamName } from 'hooks/use-team';
import { DateService } from 'services/DateService';
import { NotificationService } from 'services/NotificationService';

import { Notification, NotificationAvatar, NotificationControls } from './Notification';

import cx from './Notification.module.scss';

const Message: FC<{ notification: InboxNotification }> = ({ notification }) => {
    const { teamName } = useTeamName(notification.team);
    const { conversation, preview, url } = notification.app;
    const isUnread = !notification.readAt;

    if (!conversation) {
        return <Notification notification={notification} />;
    }

    return (
        <Box
            component={Link}
            href={url}
            onClick={() => {
                NotificationService.read(notification).then();
                NotificationService.closeInbox();
            }}
            className={cx.notification}
            data-notification={notification.id}
            data-unread={isUnread || undefined}
        >
            <Stack gap={6}>
                <Group gap="xs" justify="space-between" wrap="nowrap">
                    <Text size="xs" c="dimmed" truncate>
                        {[teamName, ...conversation.location].filter(Boolean).join(' › ')}
                    </Text>
                    <Group gap={6} wrap="nowrap" style={{ flexShrink: 0 }}>
                        <Text size="xs" c="dimmed" className={cx.date}>
                            {DateService.formatDistanceToNowShort(notification.createdAt)}
                        </Text>
                        <NotificationControls notification={notification} />
                    </Group>
                </Group>

                <Group gap="xs" wrap="nowrap" align="flex-start">
                    <NotificationAvatar notification={notification} />
                    <Box className={cx.messageBubble}>
                        <Text size="xs" fw={600} c="black">
                            {conversation.sender}
                        </Text>
                        {preview ? (
                            <Text size="sm" c="black" lineClamp={3} style={{ wordBreak: 'break-word' }}>
                                {preview}
                            </Text>
                        ) : (
                            <Text size="sm" c="dimmed" fs="italic">
                                Sent an attachment
                            </Text>
                        )}
                    </Box>
                </Group>
            </Stack>
        </Box>
    );
};

export { Message };
